import React from 'react';
import './styles.css';

function About() {
    return(
        <p className='about-text'>
            Este site apresenta o mapa do Aplicativo de Segurança da Mulher, contendo os níveis de
            segurança dos locais denunciados por mulheres por algum caso de assédio físico ou moral,
            importunação sexual ou desconforto. Assim como as possíveis respostas dos estabelecimentos
            às denúncias. Caso queira criar sua própria denúncia ou responder a uma denuncia feita ao seu
            estabelecimento, baixe o aplicativo mobile e faça seu cadastro como usuário.
        </p>
    );
}

export default About;